<template>
  <VueCookieAcceptDecline
      :debug="false"
      :disableDecline="false"
      :showPostponeButton="false"
      @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline"
      @clicked-postpone="cookieClickedPostpone"
      @removed-cookie="cookieRemovedCookie"
      @status="cookieStatus"
      elementId="main"
      position="bottom"
      ref="main"
      transitionName="slideFromBottom"
      type="bar"
  >
    <template slot="message">
      <div>
        {{$t('cookies.text.main')}}
      </div>
      <br>

      <router-link
        class="cookies-policy"
        :to="{ name: 'cookies.policy' }"
        target="_blank"
      >
        {{$t('cookies.text.policy')}}
      </router-link>
    </template>

    <template slot="declineContent">{{$t('cookies.button.deny')}}</template>
    <template slot="acceptContent">{{$t('cookies.button.accept')}}</template>
  </VueCookieAcceptDecline>
</template>

<script>
// Cookies
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import './styles/CookieAcceptDecline.scss';

export default {
components: {
  VueCookieAcceptDecline
},
data() {
  return {
    status: null,
  };
},
methods: {
  cookieStatus(status) {
    this.status = status;
  },
  cookieClickedAccept() {
    loadCookies();              // importado de public/js
    this.status = "accept";
  },
  cookieClickedDecline() {
    this.status = "decline";
  },
  cookieClickedPostpone() {
    this.status = "postpone";
  },
  cookieRemovedCookie() {
    this.status = null;
    this.$refs.main.init();
  },
},
computed: {
  statusText() {
    return this.status || "No cookie set";
  },
},
};
</script>
